import {ChangeDetectionStrategy, Component} from '@angular/core';
import {PaginationSelectors, TableCardDefinition} from '@store/aviary/aviary.adapter';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {ALWAYS} from '@aviary/components/table/table.component.types';
import {MelHintLinkComponent} from '@lib/components/mel-hint-link/mel-hint-link.component';
import {TableCardComponent} from '@aviary/components/table-card/table-card.component';
import {Hold} from '@store/holds/holds.types';
import {ReadyForPickupComponent} from '@app/my-account/holds/ready-for-pickup/ready-for-pickup.component';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {HoldsActions} from '@store/holds/holds.actions';
import {getHoldsTableColumnsDefinition, ON_HOLD_TABLE_RESPONSIVE_DEFINITION} from '@app/my-account/holds/holds.constants';
import {createStringSelector} from '@aviary/store/store.helpers';

@Component({
  selector: 'px-holds',
  host: {
    class: 'flex flex-col gap-y-7 lg:pe-10',
  },
  template: `
    @if (readyForPickupSelectors.hasItemsReadyForPickup | select) {
      <px-ready-for-pickup [isCard]="true"/>
    }

    <mx-table-card [definition]="onHoldTableCardDefinition">
      <px-mel-hint-link footer/>
    </mx-table-card>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MelHintLinkComponent, TableCardComponent, SelectPipe, ReadyForPickupComponent]
})
export class HoldsComponent {

  public readonly readyForPickupSelectors = HoldsSelectors.ReadyForPickup;

  public readonly onHoldTableCardDefinition: TableCardDefinition<Hold, typeof HoldsSelectors.OnHold> = {
    leftHeaderContent: {
      value: 'On Hold',
      count: PaginationSelectors.totalCount,
      cssClasses: 'text-headline-small lg:text-headline-medium'
    },
    actions: [
      {
        label: 'Pause All',
        clickActionCreator: HoldsActions.showPauseAllHolds,
        enabled: HoldsSelectors.OnHold.hasHolds
      }
    ],
    table: {
      defaultSelectorContainer: HoldsSelectors.OnHold,
      dataSource: 'holds',
      responsiveColumnsDefinition: ON_HOLD_TABLE_RESPONSIVE_DEFINITION,
      columns: getHoldsTableColumnsDefinition(true),
      actionIconButtons: [
        {
          iconName: 'edit',
          tooltip: hold => createStringSelector(
            HoldsSelectors.Stateless.isEditable(hold),
            isEditable => isEditable ? 'Edit Hold' : 'Holds in transit cannot be edited'
          ),
          cssClasses: {'material-icons-outlined': ALWAYS},
          clickActionCreator: HoldsActions.showEditHold,
          enabled: HoldsSelectors.Stateless.isEditable
        }
      ]
    }
  };
}
